




















import AppBanner from "@/components/AppBanner.vue";
import AppLogo from "@/components/AppLogo.vue";
import AppNav from "@/components/analytics/AppNav.vue";
import AppNavSecondary from "@/components/analytics/AppNavSecondary.vue";
import AppNavHeroku from "@/components/analytics/AppNavHeroku.vue";
import NavWrap from "@/components/NavWrap.vue";
import { Settings } from "@/types/settings";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    AppBanner,
    AppLogo,
    AppNav,
    AppNavSecondary,
    AppNavHeroku,
    NavWrap,
  },
})
export default class AppHeader extends Vue {
  @Getter("provider") provider!: string;
  @Getter("settings/activeCacheSettings") settings!: Settings;
}
